GP.GPMod('Header',function(self) {
    var vent             = self.vent;
    var _util            = self.app.Util;
    var menu_timer_delay = 330;
    var menu_timer_name  = 'header-dropdown-menu';

    var gui = {
        init: function() {
            this.$mobile_menu = $('#mobile-menu');
            this.$mobile_sidebar = $('#mobile-sidebar');
            this.$body        = $('body');
            this.$main        = $('#main');
            this.$menu_toggle = $('.navbar-toggle');
            this.$vchat_link  = $("#nav-vchat");
            this.$mobile_menu_links = $('#mobile-sidebar li:not(.dropdown) a');
            this.$footer_ad = $('#footer .footer-ad iframe');
            this.$nav_safemode_toggle = $('.nav-safemode-toggle');
            this.$nav_stealth_toggle = $('.nav-stealth-toggle');
            this.$livestream_nav_link = $('#nav-livestream-link');
            this.$livestream_tooltip = $('#livestream-tooltip');
            this.$livestream_tooltip_close = $('#livestream-tooltip .btn-close');
            this.$btn_dropdown_toggle = $('#mobile-sidebar .btn-dropdown-toggle');
        }
    };

    var apis = {

    };

    var events = {
        init: function() {
            // nav menu dropdowns
            gui.$body.on("mouseenter", "#header .header-dropdown", handlers.open_dropdown)
            .on("mouseleave", "#header .header-dropdown", handlers.hide_dropdown);

            // handle expanding mobile dropdown menus
            $('#mobile-menu li.dropdown>a').on('click', function(e) {
                e.preventDefault();
                $parent = $(this).parent();

                if ($parent.hasClass('open')) {
                    $('.header-dropdown').removeClass('open');
                } else {
                    $('.header-dropdown').removeClass('open');
                    $parent.addClass('open');
                }
            });

            // remove the href for mobile dropdown links
            $('#mobile-menu .dropdown > a').each(function(index) {
                $(this).attr('href', '#');
            });
            // upper left hand mobile menu toggle button
            gui.$menu_toggle.on('click', handlers.mobile_menu_toggle);

            // close mobile menu after clicking a link
            gui.$mobile_menu_links.on('click', handlers.close_mobile_menu);

            // event to open the mobile menu
            vent.on(self.moduleName+":open_mobile_menu", handlers.open_mobile_menu, this);

            // event to close the mobile menu
            vent.on(self.moduleName+":close_mobile_menu", handlers.close_mobile_menu, this);

            // remove videochat from nav if flash isn't enabled
            vent.on(self.moduleName+":handle_no_flash", handlers.handle_no_flash, this);

            // set current page active state on nav header
            vent.on(self.moduleName+":set_active_nav", handlers.set_active_nav, this);
            handlers.set_active_nav();

            // refresh footer ads on page change (no footer module)
            vent.on(self.moduleName+":refresh_ads", handlers.refresh_ads, this);

            gui.$nav_safemode_toggle.on('click', handlers.safemode_toggle);
            gui.$nav_stealth_toggle.on('click', handlers.stealth_toggle);

            $('.btn-trial-offer-close').on('click', handlers.trial_offer_close);

            gui.$livestream_tooltip_close.on('click', handlers.close_livestream_tooltip);
            gui.$livestream_nav_link.on('click', handlers.close_livestream_tooltip);
            vent.on(self.moduleName+":hide_livestream_tooltip", handlers.close_livestream_tooltip);

            gui.$btn_dropdown_toggle.on('click', handlers.mobile_dropdown_toggle);
        },
    };

    var handlers = {
        mobile_dropdown_toggle: function() {
            $(this).closest('li').find('.menu-dropdown').toggleClass('gp-hidden');
            $(this).closest('li').find('.menu-arrow').toggleClass('gp-rotate-180');
            $(this).closest('li').find('.btn-dropdown-toggle').toggleClass('gp-bg-neutral-800');
            $(this).closest('li').find('.dropdown-wrapper').toggleClass('gp-border gp-border-neutral-600 gp-rounded-lg');
        },
        safemode_toggle: function() {
            gui.$nav_safemode_toggle.toggleClass('on');

            window.sessionStorage.setItem('open_mobile_menu', 'true');

            if ($(this).hasClass('on')) {
                vent.trigger('User:safemode', 'on');
            } else {
                vent.trigger('User:safemode', 'off');
            }
        },
        stealth_toggle: function() {
            gui.$nav_stealth_toggle.toggleClass('on');

            if ($(this).hasClass('on')) {
                vent.trigger('Modal:open', {url: '/members/user/stealth_mode/'});
            } else {
                vent.trigger('StealthMode:disable_stealth_mode');
            }
        },

        // TODO: remove once confirmed we don't need to perform any global actions for no flash
        handle_no_flash: function(flash_detected, mobile_browser) {
            // don't hide vchat links for desktop browsers
            // even if flash isn't detected (it can ask when go live is clicked)
            if (!flash_detected && !mobile_browser) {
                return;
            }

            // otherwise hide vchat links for no flash or mobile browsers
            if (!flash_detected || mobile_browser) {
                // gui.$vchat_link.addClass('hidden');
                // $('.js-vchat-golive').hide();
            }
        },

        open_dropdown: function(e) {
            _util.timers.clear(menu_timer_name);
            $('.header-dropdown').removeClass('open');
            $(this).addClass("open");
        },
        hide_dropdown: function(e) {
            var _this = $(this);
            _util.timers.set(function() {
                _this.removeClass("open");
            }, menu_timer_delay, menu_timer_name);
        },
        open_mobile_menu: function(from_pop_state) {
            vent.trigger('RightDrawer:hide');
            gui.$body.addClass('mobile-menu-open');
            gui.$mobile_sidebar.addClass('gp-transform-none');

            $('#mobile-menu-overlay').remove();
            var $overlay = $('<div/>').addClass('modal-backdrop in').attr('id', 'mobile-menu-overlay');
            $('body').append($overlay);

            // close overlay and menu when the overlay is clicked
            $overlay.add('#header').one('click', function() {
                handlers.close_mobile_menu();
            });

            $(window).scrollTop(0);

            // if (!from_pop_state) {
            //     var state = {
            //         mobile_menu: true
            //     };
            //     vent.trigger("Page:push_state", state);
            // }
        },
        close_mobile_menu: function() {
            gui.$body.removeClass('mobile-menu-open');
            gui.$mobile_sidebar.removeClass('gp-transform-none');
            gui.$mobile_sidebar.find('.menu-dropdown').addClass('gp-hidden');
            gui.$mobile_sidebar.find('.menu-arrow').removeClass('gp-rotate-180');
            gui.$mobile_sidebar.find('.scroll-wrapper').scrollTop(0);
            $('#mobile-menu-overlay').remove();
        },
        mobile_menu_toggle: function(e) {
            e.preventDefault();
            e.stopPropagation();
            if ($('body').hasClass('mobile-menu-open')) {
                handlers.close_mobile_menu();
            } else {
                handlers.open_mobile_menu();
            }
        },
        set_active_nav: function(e) {
            $('#header .navbar-nav > li').removeClass('active');

            var loc_path = window.location.pathname.split('/');
            var qs_path = window.location.search;
            var cur_page = '';
            if (loc_path.length < 3) {
                // old school url /main.php?a=something.something...
                var qs = qs_path.match(/a=\w+\.(\w+)/i);
                if (qs && qs.length > 1) {
                    cur_page = qs[1];
                }
            } else {
                cur_page =  loc_path[3].toLowerCase();
            }

            // if duid is not in url, it's your profile.
            if (cur_page == 'profile' && qs_path.indexOf("duid") < 0) {
                cur_page = 'my_profile';
            }

            // check for online now page.
            if (cur_page == 'quicksearch' && qs_path.indexOf("online") !== -1) {
                cur_page = 'online';
            }

            if (loc_path.includes('chat') && loc_path.includes('home')) {
                cur_page = 'chat';
            }

            switch (cur_page) {
                case 'home':
                    $('#nav-home').addClass('active');
                    break;
                case 'quicksearch':
                case 'popular':
                case 'browse':
                case 'newfaces':
                case 'viewed':
                    $('#nav-search').addClass('active');
                    break;
                case 'online':
                    $('#nav-online').addClass('active');
                    break;
                case 'chat':
                    $('#nav-chat').addClass('active');
                    break;
                case 'picture':
                case 'pictures':
                case 'video':
                case 'videos':
                case 'trending':
                    $('#nav-galleries').addClass('active');
                    break;
                case 'hotpick':
                    $('#nav-match').addClass('active');
                    break;
                case 'flinglivegirls':
                    $('#nav-cams').addClass('active');
                    break;
                case 'specials':
                    $('#nav-specials').addClass('active');
                    break;
                case 'my_profile':
                    $('#nav-profile').addClass('active');
                    break;
                case 'live_action':
                    $('#nav-live-action').addClass('active');
                    break;
                default:
            }
        },
        trial_offer_close: function() {
            $('.trial-upgrade-offer-wrap').css('display', 'none');
            _util.set_cookie('fl_trl_hd', 1, 2);
        },
        close_livestream_tooltip: function() {
            gui.$livestream_tooltip.hide();
            handlers.set_livestream_cookie();
        },
        set_livestream_cookie: function() {
            _util.set_cookie('fl_ls_tt',  1, 365);
        }
    };

    this.addInitializer(function() {
        gui.init();
        events.init();
    });
});

